import { render, staticRenderFns } from "./ActionIconButton.vue?vue&type=template&id=0fcf5a39&"
import script from "./ActionIconButton.vue?vue&type=script&lang=js&"
export * from "./ActionIconButton.vue?vue&type=script&lang=js&"
import style0 from "./ActionIconButton.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports